import { tap } from "rxjs/operators";
import { Directive, OnInit } from "@angular/core";
import { Model, Wallet } from "@models";
import { Observable } from "rxjs";
import { BpModalCanDismiss } from "@models/interfaces/bp-modal-can-dismiss";
import { Currency } from "@models/interfaces/currency";
import { ModalHeader } from "@models/modal_step";
import { TrackingModal } from "../tracking-modal/tracking.modal";
import { ConfirmModalService } from "@core-services/confirm-modal.service";

@Directive()
export abstract class StepSummaryModal extends TrackingModal implements OnInit, BpModalCanDismiss {
	public tradableId: string = null;
	private _sum: boolean = false;
	public filterType: typeof Currency = Currency;

	public edit: number = 0;
	public created: boolean = false;
	public saved: boolean = false;
	public preselected: Wallet = null;
	protected directTransfer: boolean = false;

	public constructor(protected confirmModalService: ConfirmModalService) {
		super();
	}

	public get summary(): boolean {
		return this._sum;
	}

	public ngOnInit(): void {
		if (this.data && this.data.hasOwnProperty("preselected")) {
			this.preselected = this.data.preselected;
			delete this.data["preselected"];
		}
		this.trackInitiated();
	}

	public set summary(sum: boolean) {
		this._sum = sum;
	}

	public get dirty(): boolean {
		return !this.isFirstStep;
	}

	public done(): void {
		this.saved = true;
		this.trackSuccess();
		super.close();
	}

	public cancelDirectTrade(): void {
		this.modalService.getCurrentModal().dismiss();
	}

	public close(abort: boolean = false): void {
		if (abort) {
			this.trackCancel();
		}
		super.close();
	}

	public modalCanDismiss(): boolean | Observable<boolean> {
		if (this.dirty && !this.saved) {
			return this.confirmModalService.showConfirmModal("close_window?", "unsaved_data_will_get_lost").pipe(
				tap((a) => {
					if (a) {
						this.trackCancel();
					}
				})
			);
		}
		return true;
	}

	public finish(): void {
		this.summary = true;
		this.trackSummary();
		this.doTrapFocusTime();
	}

	public isSame(object1: Model, object2: Model): boolean {
		if (object1 == null || object2 == null) {
			return false;
		}

		return object1.getId() === object2.getId();
	}

	public setEdit(e: number, summary = false): void {
		this.edit = +e;
		this.summary = summary;
		this.tradableId = null;
		if (summary && this.data.hasOwnProperty("cryptocoin_id")) {
			this.tradableId = this.data["cryptocoin_id"];
		}
		this.doTrapFocusTime();
	}

	public isEdit(e: number): boolean {
		return this.edit === e;
	}

	public abstract get isFirstStep(): boolean;

	public abstract get isSecondStep(): boolean;

	public abstract get isThirdStep(): boolean;

	public abstract get currentStep(): ModalHeader;

	public get stepNumber(): number {
		return this.isFirstStep ? 1 : this.isSecondStep ? 2 : this.isThirdStep ? 3 : 0;
	}

	protected getDefaultHeader(title: string): ModalHeader {
		return { step: this.stepNumber, title };
	}

	public onHeaderButtonClick(name: string): void {
		if (name === "cancel") {
			this.cancelDirectTrade();
		} else if (name === "ok") {
			this.setEdit(0, true);
		} else if (name === "abort") {
			this.closeAll();
		}
	}

	protected translate(key: string, value: (number | string)[] = null): string {
		return this.translationService.translate(key, value);
	}

	protected trackCancel(): void {
		const step = this.summary
			? "summary"
			: (this.isFirstStep ? "first" : this.isSecondStep ? "second" : "third") + "_step";
		super.trackCancel(step);
	}
}
